import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import { Http, Response } from '@angular/http';
import { HelperService } from '../helper.service';
import {MatSnackBar} from '@angular/material';
import {CookieService} from 'angular2-cookie/core';

@Component({
  selector: 'app-forgot-password-component',
  templateUrl: './forgot-password-component.component.html',
  styleUrls: ['./forgot-password-component.component.css']
})
export class ForgotPasswordComponentComponent implements OnInit {

  constructor(private router: Router,private http: Http,private helper:HelperService,private snackbar:MatSnackBar,private cookie:CookieService) { }

  ngOnInit() {
  }
  forgot(forgotpassword: NgForm){
    let body = new FormData();
    
    //alert(forgotpassword.value.email);
    if(forgotpassword.value.email)
    {
      body.append('email', forgotpassword.value.email);
      this.http.post(this.helper.base_url+'http/forgotpassword', body)
      .subscribe(
        (res) => {
        let user=JSON.parse(res['_body'] )[0] ;
        if(res['_body']!="0") {

        // this.cookie.put('auth','Y');
        // this.cookie.put('user_id',user.id);
        // this.cookie.put('user_image',user.image);

        this.snackbar.open('Please Check Your Mail For Reset Link', null, {
        duration:7000,
          extraClasses:'success-snackbar',
          verticalPosition:'top'
        });
          //this.router.navigate(["/dashboard"]);
      }else{
        this.snackbar.open('Wrong Credantials', null, {
        duration:5000,
          extraClasses:'error-snackbar',
          verticalPosition:'top'
        });
      }
        }, //For Success Response
          err => {console.error(err)} //For Error Response);
      );
    }
    else
    {
      this.snackbar.open('Provide an email', null, {
          duration:5000,
            extraClasses:'error-snackbar',
            verticalPosition:'top'
          });
    }
    // body.append('email', forgotpassword.value.email);
    // body.append('password', forgotpassword.value.password);
  
    //  this.http.post(this.helper.base_url+'http/login', body)
    //  .subscribe(
    //    (res) => {
    //    let user=JSON.parse(res['_body'] )[0] ;
    //    if(res['_body']!="0") {
  
    //    this.cookie.put('auth','Y');
    //    this.cookie.put('user_id',user.id);
    //    this.cookie.put('user_image',user.image);
  
    //   this.snackbar.open('Welcome', null, {
    //   duration:5000,
    //     extraClasses:'success-snackbar',
    //     verticalPosition:'bottom'
    //   });
    //      this.router.navigate(["/dashboard"]);
    // }else{
    //   this.snackbar.open('Wrong Credantials', null, {
    //   duration:5000,
    //     extraClasses:'error-snackbar',
    //     verticalPosition:'bottom'
    //   });
    // }
    //    }, //For Success Response
    //     err => {console.error(err)} //For Error Response);
    //  );
    }

}



// WEBPACK FOOTER //
// ./src/app/forgot-password-component/forgot-password-component.component.ts